module.exports = __webpack_public_path__ + "img/mobile-app.e4ef3dd4.svg";